import React from 'react'
import classnames from 'classnames'
import './layout.css'

const AppLayout = ({isEmbedded = false, children}) => (
  <div className={classnames({
    'layout--wrapper': true,
    'layout--wrapper__embedded': isEmbedded,
  })}>
    <div className="layout--content">
      {children}
    </div>
  </div>
)

export default AppLayout



// WEBPACK FOOTER //
// ./src/layout/index.jsx